<template>
  <div class="calculate">
    <Nav only />
    <div class="map-bar">
      <div class="from">
        <Input v-model="zipcode" placeholder="Zip code" class="input shipfrom" size="large" label="Ship From">
          <div slot="bottom" class="require">{{ zipcodeMsg }}</div>
        </Input>
        <InputWrap class="input shipdate" size="large" label="Ship Date">
          <i-date-picker
            v-model="shipdate"
            :options="options"
            size="large"
            format="MM/dd/yy"
            placeholder="mm/dd/yy"
            @on-change="rshipdate = ''"
          />
          <div slot="bottom" class="require">{{ shipdateMsg }}</div>
        </InputWrap>
        <Input v-model="count" class="input count" type="number" size="large" label="Package Counts">
          <div slot="bottom" class="require">{{ countMsg }}</div>
        </Input>
        <Input v-model="weight" class="input weight" type="number" size="large" label="Total Weight">
          <span slot="suffix" class="suffix">LB</span>
          <div slot="bottom" class="require">{{ weightMsg }}</div>
        </Input>
        <Input
          v-model="rzipcode"
          class="input postcode"
          :disabled="uncertainReturn"
          size="large"
          label="Return To"
          placeholder="Zip code"
        >
          <i-check-box slot="right" v-model="uncertainReturn" class="right" @on-change="rzipcode = ''">
            <span>Uncertain</span>
          </i-check-box>
          <div slot="bottom" class="require">{{ rzipcodeMsg }}</div>
        </Input>
        <InputWrap class="input returndate" size="large" label="Receipt Date">
          <i-date-picker
            v-model="rshipdate"
            :options="optionsReturn"
            :disabled="uncertainDate"
            size="large"
            format="MM/dd/yy"
            placeholder="mm/dd/yy"
          />
          <i-check-box slot="right" v-model="uncertainDate" class="right" @on-change="rshipdate = ''">
            <span>Uncertain</span>
          </i-check-box>
          <div slot="bottom" class="require">{{ rshipdateMsg }}</div>
        </InputWrap>
        <Button :loading="loading" class="input btn" @click="getStarted">Show Rates</Button>
      </div>
    </div>
    <div class="map-container">
      <div v-show="showPop" class="pop">
        <Error v-if="searchError" :title="searchErrorTitle">
          <span>{{ searchError }}</span>
        </Error>
        <Result
          v-else
          class="animate__animated animate__faster animate__lightSpeedInLeft"
          :loading="loading"
          :cur-house="curHouse"
          :calculate="calculate"
          @nextStep="nextStep"
          @changeWaveHouse="changeWaveHouse"
        ></Result>
      </div>
      <div class="map">
        <i-spin v-if="!mapLoaded" fix>
          <i-icon type="ios-loading" size="40" class="spin-icon-load" />
        </i-spin>
        <div id="map"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../../components/comm/Nav.vue';
import Input from '../../components/input/Input';
import Button from '../../components/button/Button';
import InputWrap from '../../components/input/InputWrap';
import Error from './components/Error';
import Result from './components/Result';
import svgPaths from './path.json';

import { mapActions, mapState } from 'vuex';
import jsLoader from '../../utils/jsLoader';
import moment from 'moment';

const wavehouseIcon = require('../../assets/imgs/calculate-wavehouse.png');
const carIcon = require('../../assets/imgs/calculate-huoche.png');
const locationIcon = require('../../assets/imgs/calculate-location.png');
const rmIcon = require('../../assets/imgs/rm.png');
export default {
  components: {
    Nav,
    Input,
    InputWrap,
    Button,
    Error,
    Result,
  },
  data() {
    return {
      markers: [],
      zipcode: '',
      shipdate: new Date(),
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      optionsReturn: {
        disabledDate: date => {
          return date && date.valueOf() < this.shipdate.valueOf() + 86400000 * 2;
        },
      },
      weight: '',
      uncertainReturn: false,
      uncertainDate: false,
      rzipcode: '',
      rshipdate: '',
      loading: false,
      showPop: false,
      calculate: {},
      count: '',
      curHouse: null,
      tagList: [],
      searchErrorTitle: 'ERROR',
      searchError: '',
      zipcodeMsg: '',
      shipdateMsg: '',
      countMsg: '',
      weightMsg: '',
      rzipcodeMsg: '',
      rshipdateMsg: '',
      loadMapLoading: false,
      mapLoaded: false,
    };
  },
  mounted() {
    this._codeMaker = {};
    this._recommandedMaker = null;
    this._navagationPolyline = [];
    this._cartMaker = null;
    this._startMaker = null;
    this._stopMaker = null;
    //修改仓库，之前选择的code
    this._houseId = '';
    this.initQuery();
    this.$maps = {};
    this.$nextTick(() => {
      this.loadGoolemapJs();
    });
  },
  beforeDestroy() {
    this.$bus.$emit('clearSendPackge');
  },
  methods: {
    ...mapActions('calculate', ['search', 'getWareHouse']),
    loadGoolemapJs() {
      if (this.mapLoaded) {
        return true;
      }
      this.loadMapLoading = true;
      this.mapLoaded = false;
      jsLoader(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyBZhHEG1ZINGM7scAC6fBpHP3CgVyh-jd0&libraries=places&v=weekly',
        'google',
      )
        .then(() => {
          this.loadMapLoading = false;
          this.mapLoaded = true;
          this.$maps = window.google.maps;
          this.initMap();
        })
        .catch(() => {
          //TODO 是否提示加载错误？
          this.loadMapLoading = false;
        });
    },
    initQuery() {
      let { query } = this.$route;
      if (query.zipcode) {
        this.zipcode = this.$route.query.zipcode;
      }
      if (query.change) {
        let { shipdate, weight, uncertainReturn, uncertainDate, rzipcode, rshipdate, count, houseId } = query;
        this.shipdate = shipdate;
        this.weight = weight;
        this.uncertainReturn = uncertainReturn === 'true';
        this.uncertainDate = uncertainDate === 'true';
        this.rzipcode = rzipcode;
        this.rshipdate = rshipdate;
        this.count = count;
        this._houseId = houseId;
        this.getStarted();
      } else {
        this.initWaveHouse();
      }
    },
    getStarted() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.showPop = false;
      this.searchError = '';
      if (this.warehouse.length === 0) {
        this.initWaveHouse(() => {
          this.searchCalculate();
        });
      } else {
        this.searchCalculate();
      }
    },
    searchCalculate() {
      this.hideMaker();
      (this.zipcodeMsg = ''),
        (this.shipdateMsg = ''),
        (this.countMsg = ''),
        (this.weightMsg = ''),
        (this.rzipcodeMsg = ''),
        (this.rshipdateMsg = '');
      if (!this.zipcode) {
        this.zipcodeMsg = 'Required';
        this.loading = false;
        return false;
      }
      if (!this.shipdate) {
        this.shipdateMsg = 'Required';
        this.loading = false;
        return false;
      }
      if (!this.count) {
        this.countMsg = 'Required';
        this.loading = false;
        return false;
      }
      if (!this.weight) {
        this.weightMsg = 'Required';
        this.loading = false;
        return false;
      }
      if (!this.uncertainReturn && this.rzipcode == '') {
        this.rzipcodeMsg = 'Required';
        this.loading = false;
        return false;
      }
      if (!this.uncertainDate && this.rshipdate == '') {
        this.rshipdateMsg = 'Required';
        this.loading = false;
        return false;
      }
      this.search({
        zipcode: this.zipcode,
        shipdate: this.shipdate,
        weight: this.weight,
        uncertainReturn: this.uncertainReturn,
        uncertainDate: this.uncertainDate,
        rzipcode: this.uncertainReturn ? '' : this.rzipcode,
        rshipdate: this.uncertainDate ? '' : this.rshipdate,
        count: this.count,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            let data = res.data;
            this._bestHouse = data.bestHouse;
            this._kiteHouse = data.kiteHouse;
            let calculate = this._kiteHouse[this._bestHouse];
            this.setCalculate(calculate);
            this.checkWaveHouse();
            if (this.mapLoaded) {
              if (this._houseId) {
                this.searchHouse({ houseId: this._houseId });
              }
              this.addNavagation();
            } else {
              this.$Message.error('loaded google map error.');
            }
          } else {
            this.showPop = true;
            if (res.message === "We don't have enough time to handle your package") {
              this.searchErrorTitle = 'The receipt date is too early! ';
            } else {
              this.searchErrorTitle = 'ERROR';
            }
            this.searchError = res.message;
          }
        })
        .catch(() => {
          this.init = false;
          this.loading = false;
        });
    },
    searchHouse({ houseId }) {
      let warehouse = this.warehouse;
      if (this.calculate['houseId'] !== houseId) {
        let calculate = this._kiteHouse[houseId];
        if (calculate) {
          this.setCalculate(calculate);
          this.curHouse = warehouse.find(house => house.houseId === houseId);
          let cpoint = new this.$maps.LatLng(this.curHouse.lat, this.curHouse.lng);
          this._map.setCenter(cpoint);
          this.addNavagation();
        }
      }
    },
    changeWaveHouse(house) {
      this.searchHouse(house);
    },
    setCalculate(calculate = {}) {
      this.calculate = calculate;
    },
    cleanNavagation() {
      this._navagationPolyline.forEach(it => it.setMap(null));
      this._navagationPolyline.splice(0);
    },
    addNavagation() {
      if (this.zipcode || this.rzipcode) {
        let point = null;
        this.geoZipCode(this.zipcode)
          .then(r => {
            point = r;
            if (this._startMaker) {
              this._startMaker.setMap(null);
            }
            this._startMaker = this.addMaker(point);
            return this.geoZipCode(this.rzipcode);
          })
          .then(rpoint => {
            this.cleanNavagation();
            var bounds = new this.$maps.LatLngBounds();
            let apoint = new this.$maps.LatLng(this.curHouse.lat, this.curHouse.lng);
            let routes = [point, apoint];
            if (rpoint) {
              routes.push(rpoint);
            }
            routes.forEach(route => {
              bounds.extend(route);
            });
            if (this._cartMaker) {
              this._cartMaker.setMap(null);
              this._cartMaker = null;
            }
            this._map.fitBounds(bounds);
            if (this._stopMaker) {
              this._stopMaker.setMap(null);
            }
            if (rpoint) {
              this._stopMaker = this.addMaker(rpoint);
            }
            this.addPolyLine(routes);
          });
      }
    },
    nextStep() {
      let query = {
        zipcode: this.zipcode,
        shipdate: moment(this.shipdate).format('MM/DD/YY'),
        weight: this.weight,
        uncertainReturn: this.uncertainReturn,
        uncertainDate: this.uncertainDate,
        rzipcode: this.rzipcode,
        rshipdate: moment(this.rshipdate).format('MM/DD/YY'),
        count: this.count,
        name: this.curHouse.name,
        houseId: this.curHouse.houseId,
      };
      if (this.$route.query.change) {
        query.select = 1;
      }
      this.$router.push({
        path: '/send/new',
        query: query,
      });
    },
    checkWaveHouse() {
      let warehouse = this.warehouse,
        _kiteHouse = this._kiteHouse;
      if (this.mapLoaded) {
        if (!this._initMaker) {
          this.addWaveHouseMaker();
        }
      }
      warehouse.forEach(house => {
        let { houseId, lat, lng } = house;
        let _maker = this._codeMaker[houseId];
        if (_kiteHouse[houseId] && _kiteHouse[houseId].enable) {
          _maker && _maker.setOpacity(1);
          if (houseId === this._bestHouse) {
            this.curHouse = house;
            if (this.mapLoaded) {
              this.addRecommandedHouseMaker(lat, lng);
            }
          }
        } else {
          _maker && _maker.setOpacity(0);
        }
      });
    },
    initMap() {
      var dom = document.getElementById('map');
      const map = new this.$maps.Map(dom, {
        zoom: 5,
        mapTypeId: 'terrain',
        disableDefaultUI: true,
      });
      map.setCenter({ lat: 37.2755928, lng: -104.6569351 });
      this._map = map;
      this._geocoder = new this.$maps.Geocoder();
    },
    addPolyLine(points) {
      const polyLineArr = [];

      //添加第一段
      polyLineArr[0] = this.conPolyLine(points[0], points[1]);

      //添加第二段
      if (points.length === 3) {
        polyLineArr[1] = this.conPolyLine(points[1], points[2]);
      }

      this._navagationPolyline.push(...polyLineArr);
      this.startHuocheAnimate(polyLineArr);
    },
    conPolyLine(pointA, pointB) {
      const lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        scale: 2,
      };
      const lineSymbolCar = {
        path: pointA.lng() > pointB.lng() ? svgPaths.left : svgPaths.right,
        scale: 1,
        fillColor: '#6E6DEF',
        fillOpacity: 0, //默认不显示图标，由动画控制是否显示
        rotation: 0,
        fixedRotation: true,
      };
      return new this.$maps.Polyline({
        path: [pointA, pointB],
        geodesic: false,
        strokeColor: '#FF7070',
        strokeOpacity: 0,
        strokeWeight: 2,
        strokeStyle: 'dashed',
        icons: [
          { icon: lineSymbol, offset: '0', repeat: '20px' },
          { icon: lineSymbolCar, offset: '100%' },
        ],
        map: this._map,
      });
    },
    addMaker(location, label = '') {
      return new this.$maps.Marker({
        position: location,
        map: this._map,
        icon: {
          url: locationIcon,
          scaledSize: {
            width: 33,
            height: 40,
          },
        },
        label: label,
      });
    },

    /**
     * 给货车添加动画
     * 基于官方示例 https://developers.google.cn/maps/documentation/javascript/symbols?hl=zh-cn#animate
     *
     * 如果按照官方示例使用一条polyLine，当遇到左右折角的路线（如： < ），卡车在第二段会变成头朝下前进
     * 此问题在对称图形上不会出现
     * 所以需要将线路分为两段（或多段），每段使用其对应方向的卡车Symbol
     * 所以polyLineArr接收一个Polyline数组
     * 每个Polyline包含虚线线段和一个隐藏的卡车Symbol
     * 此方法循环每个Polyline(通过index = (index + 1) % polyLineArr.length控制)
     * 当第一段Polyline跑完后隐藏第一段的卡车并显示第二段的卡车
     * @param polyLineArr
     */
    startHuocheAnimate(polyLineArr) {
      let count = 200;
      /**
       * 官方示例中没有定义stepper，默认为count + 1，即每20ms前进1%
       * 当两段线长度不同时，stepper==1会导致卡车在两段线上的速度不同（因为时间相同：每20ms前进1%）
       * 为了让卡车在每段线上的速度相同，为每一段分别使用不同的步进stepper
       * 通过方法calcStepperRate计算
       */
      let stepperRate = this.calcStepperRate(polyLineArr);
      let stepper = stepperRate.lastItem;
      let index = polyLineArr.lastIndex;
      let flightPath = polyLineArr[index];
      window.setInterval(() => {
        count = count + stepper;
        if (count > 200 && polyLineArr.length > 1) {
          //如果一段跑完(count > 200)，则切换下一段
          const icons1 = flightPath.get('icons');
          icons1[1].icon.fillOpacity = 0; //使当前的透明
          flightPath.set('icons', icons1); //应用，否则不生效
          index = (index + 1) % polyLineArr.length; //切换下一段
          flightPath = polyLineArr[index];
          stepper = stepperRate[index];
        }
        count = count % 200;
        const icons = flightPath.get('icons');
        icons[1].offset = count / 2 + '%';
        icons[1].icon.fillOpacity = 1; //切换后的不透明
        flightPath.set('icons', icons);
      }, 20);
    },
    /**
     * 为了让卡车在每段线上的速度相同，为每一段分别计算不同的步进stepper
     * 卡车在sum长度上每次行进1%的长度所对应到每一段上行进的百分比
     * 如 d0=60, d1=40, sum=100时，卡车每行进1%，就要在d0上前进1.66%，则rateArr[0]=1.66
     */
    calcStepperRate(polyLineArr) {
      if (polyLineArr.length === 1) return [1];
      const distanceArr = [];
      let sum = 0;
      for (let polyLine of polyLineArr) {
        //计算每条线段的距离
        distanceArr.push(this.twoPointDistance(polyLine.getPath().getAt(0), polyLine.getPath().getAt(1)));
        sum += distanceArr.lastItem;
      }
      const rateArr = [];
      for (let dis of distanceArr) {
        rateArr.push(((sum * 0.01) / dis) * 100); // 计算每一段的步进百分比
      }
      return rateArr;
    },
    /**
     * 计算两点之间的距离
     * p1,p2 API: https://developers.google.cn/maps/documentation/javascript/reference/3.53/coordinates?hl=en#LatLng
     * @param p1 google.maps.LatLng
     * @param p2 google.maps.LatLng
     */
    twoPointDistance(p1, p2) {
      return Math.sqrt(Math.pow(p1.lat() - p2.lat(), 2) + Math.pow(p1.lng() - p2.lng(), 2));
    },
    geoZipCode(zipcode) {
      return new Promise(resolve => {
        this._geocoder.geocode({ address: zipcode }, function(results, status) {
          if (status === 'OK') {
            let point = results[0].geometry.location;
            resolve(point);
          } else {
            resolve(null);
          }
        });
      });
    },
    addWaveHouseMaker() {
      let warehouse = this.warehouse;
      let map = this._map;
      this._initMaker = true;
      var bounds = new this.$maps.LatLngBounds();
      warehouse.forEach(house => {
        let point = new this.$maps.LatLng(house.lat, house.lng);
        let maker = new this.$maps.Marker({
          position: point,
          icon: {
            url: wavehouseIcon,
            scaledSize: {
              width: 27,
              height: 26,
            },
          },
          opacity: 0.2,
        });
        maker.addListener('click', () => {
          this.searchHouse(house);
        });
        maker.setMap(map);
        if (!this._codeMaker) {
          this._codeMaker = {};
        }
        this._codeMaker[house.houseId] = maker;
        bounds.extend(point);
      });
      this._map.setCenter(bounds.getCenter());
    },
    hideMaker() {
      this.warehouse.forEach(({ houseId }) => {
        this._codeMaker[houseId] && this._codeMaker[houseId].setOpacity(0);
      });
      if (this._recommandedMaker) {
        this._recommandedMaker.setMap(null);
      }
    },
    addRecommandedHouseMaker(lat, lng) {
      let location = new this.$maps.LatLng(lat, lng);
      this._recommandedMaker = new this.$maps.Marker({
        position: location,
        icon: {
          url: rmIcon,
          scaledSize: {
            width: 125,
            height: 53,
          },
          anchor: {
            y: 80,
            x: 64,
          },
        },
        map: this._map,
      });
      this._recommandedMaker.addListener('click', () => {
        this.searchHouse({
          code: this._bestHouse,
        });
      });
    },
    initWaveHouse(cb) {
      this.getWareHouse()
        .then(res => {
          if (res.success) {
            cb && cb();
          } else {
            setTimeout(() => {
              this.initWaveHouse(cb);
            }, 1500);
          }
        })
        .catch(e => {
          console.log(e);
          setTimeout(() => {
            this.initWaveHouse(cb);
          }, 1500);
        });
    },
  },
  computed: {
    ...mapState('calculate', ['warehouse']),
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.calculate {
  height: 100%;
  padding-top: 86px;
  position: relative;
  .map-bar {
    height: 136px;
    z-index: 99999;
    left: 0;
    top: 0;
    right: 0;
    .from {
      display: flex;
      height: 100%;
      flex-direction: row;
      align-items: center;
      padding-left: 26px;
      .require {
        .font-regular;
        font-size: 15px;
        height: 20px;
        min-width: 1px;
        line-height: 20px;
        color: @app-error-color;
      }
      .input {
        margin-left: 30px;
        &.shipfrom,
        &.weight,
        &.count {
          width: 126px;
        }
        &.shipdate {
          width: 186px;
        }
        &.postcode,
        &.returndate {
          width: 206px;
        }
        &.btn {
          margin-left: 50px;
        }
        .suffix {
          .font-light;
          font-size: 14px;
          font-weight: 300;
          color: #d8dce2;
          line-height: 36px;
        }
        .right {
          .font-light;
          font-size: 14px;
          font-weight: 300;
          color: @app-black-color;
        }
      }
    }
  }
  .map-container {
    width: 100%;
    height: calc(~'100% - 136px');
    position: relative;
    display: flex;
    flex-direction: row;
    .map {
      height: 100%;
      flex: 1;
      background-color: #f2f2f2;
      position: relative;
      #map {
        width: 100%;
        height: 100%;
      }
    }
    .pop {
      // position: absolute;
      // z-index: 8;
      // opacity: 0.8;
      // left: 56px;
      // top: 30px;
      height: 100%;
      width: 420px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(191, 191, 193, 0.3);
    }
  }
}
</style>
